export const breakpoints = [
  /* DO NOT ADD/REMOVE */
  '48em', // 768px
  '64em', // 1024px
  '80em', // 1280px
  '90em', // 1440px
  /* DO NOT ADD/REMOVE */
];
